import React from 'react'
import Headersm from './Headersm'
import Bigscreenheader from './Bigscreenheader'

const Nav = () => {
  return (
    <div>
      <Headersm/>
      <Bigscreenheader/>
    </div>
  )
}

export default Nav